import { useTranslation } from 'react-i18next'

import Section from '../components/Section'

interface TextSection {
  heading: string
  body: string[]
}

// Plain "heading + paragraphs" blocks, in document order.
const BODY_KEYS = [
  'controller',
  'afterSubmit',
  'retention',
  'recipients',
  'rights',
  'ai',
  'changes',
] as const

// The four data-collection sub-blocks under "2. What personal data is
// collected, and why" - each is a heading, one explanatory paragraph, and
// (except language, which is purely functional) a legal-basis line.
const DATA_KEYS = ['contactForm', 'quoteForm', 'chat', 'antiSpam', 'ip', 'language'] as const

function PrivacyPage() {
  const { t } = useTranslation()

  const sections: TextSection[] = BODY_KEYS.map((key) => ({
    heading: t(`legal.privacy.${key}Heading`),
    body: t(`legal.privacy.${key}Body`, { returnObjects: true }) as string[],
  }))

  return (
    <div className="legal-page">
      <Section background="surface" space="md" className="legal-hero">
        <h1 className="display">{t('legal.privacy.title')}</h1>
        <p className="legal-updated">
          {t('legal.updatedLabel', { date: t('legal.lastUpdated') })}
        </p>
        <p className="legal-lead">{t('legal.privacy.intro')}</p>
      </Section>

      <Section background="beige" space="lg" className="legal-body">
        <article className="legal-article">
          <h2>{t(`legal.privacy.controllerHeading`)}</h2>
          {(t('legal.privacy.controllerBody', { returnObjects: true }) as string[]).map(
            (para) => (
              <p key={para}>{para}</p>
            ),
          )}

          <h2>{t('legal.privacy.dataHeading')}</h2>
          {DATA_KEYS.map((key) => (
            <div key={key} className="legal-subsection">
              <h3>{t(`legal.privacy.${key}Heading`)}</h3>
              <p>{t(`legal.privacy.${key}Body`)}</p>
              {key !== 'language' && (
                <p className="legal-basis">{t(`legal.privacy.${key}Basis`)}</p>
              )}
            </div>
          ))}

          {sections.slice(1).map((section) => (
            <section key={section.heading}>
              <h2>{section.heading}</h2>
              {section.body.map((para) => (
                <p key={para}>{para}</p>
              ))}
            </section>
          ))}
        </article>
      </Section>
    </div>
  )
}

export default PrivacyPage
